<template>
    <div class="image-container">
        <vx-image-preview
            title="Image Preview"
            :active.sync="previewActive"
            :src="imageSrc"
            :alt="sourceId"
        />
        <vx-card class="vx-image with-preview">
            <template slot="no-body">
                <div v-if="imageSrc && !error" class="img-wrapper">
                    <img
                        :src="imageSrc"
                        @error="error = true"
                        @click.stop.prevent="previewActive = true"
                    />
                </div>
                <div v-else class="broken-image p-2">
                    <vx-basic-icon size="9" use-mdi icon="broken_image" />
                    <span class="no-img-text">Image Unavailable</span>
                </div>
            </template>
        </vx-card>
    </div>
</template>

<script>
import { guid } from '../../plugins/helpers/regex_helpers'

export default {
    name: 'vx-image',
    props: {
        sourceId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            error: false,
            imageSrc: null,
            previewActive: false
        }
    },
    watch: {
        sourceId: {
            handler: function (newId) {
                if (newId) {
                    this.fetchImageById()
                }
            },
            immediate: true
        }
    },
    methods: {
        async fetchImageById() {
            if (!this.sourceId) {
                this.imageSrc = null
                return
            }
            if (guid.IS_VALID_REGEX.test(this.sourceId)) {
                let response = this.$api.resources.getUrlFromGuid(this.sourceId)
                this.imageSrc = response
                return
            }
            this.imageSrc = this.sourceId
        }
    },
    mounted() {
        this.fetchImageById()
    }
}
</script>

<style lang="scss" scoped>
.vx-image {
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 85px;
    max-height: 85px;
    min-width: 64px;
    min-height: 64px;
    & .img-wrapper {
        height: 100%;
        width: 100%;
        overflow: hidden;
        cursor: zoom-in;
        & img {
            width: 100%;
            height: auto;
            padding: 4px;
        }
    }
    & .broken-image {
        max-width: 85px;
        max-height: 85px;
        min-width: 64px;
        min-height: 64px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        background: rgba(255, 255, 255, 0.15);
        & .no-img-text {
            font-size: 10px;
        }
    }
}
</style>
